(() => {
  if (window.saunaPostcodeDeliveryLoaded) return;
  window.saunaPostcodeDeliveryLoaded = true;

  const METRO_RANGES = [
    [2000, 2234], [2557, 2559], [2564, 2567], [2740, 2744],
    [2747, 2751], [2759, 2764], [2766, 2774], [2776, 2777],
    [2890, 2897], [3000, 3099], [3101, 3207], [3800, 3801],
    [4000, 4207], [4300, 4305], [4500, 4519], [5000, 5199],
    [6000, 6199], [2600, 2620], [2900, 2920]
  ];
  const AUSTRALIAN_RANGES = [
    [200, 299], [800, 999], [2000, 2999], [3000, 3999],
    [4000, 4999], [5000, 5799], [6000, 6797], [7000, 7799]
  ];
  const ASSEMBLY_RANGES = [[3000, 3999], [7000, 7799]];
  const inRanges = (postcode, ranges) => {
    const number = Number(postcode);
    return ranges.some(([start, end]) => number >= start && number <= end);
  };
  function updateDelivery(field) {
    const root = field.closest('[data-sauna-configurator]');
    const priceInput = root?.querySelector('[data-delivery-price]');
    const status = root?.querySelector('[data-postcode-status]');
    const assemblyGroup = root?.querySelector('[data-assembly-service]');
    if (!root || !priceInput || !status) return;
    const postcode = field.value.trim();
    let valid = false;
    let price = 0;
    let message = 'Please enter a valid 4-digit postcode.';
    let value = '';
    if (/^\d{4}$/.test(postcode)) {
      if (!inRanges(postcode, AUSTRALIAN_RANGES)) {
        message = 'Invalid postcode. Please call 1800 214 121.';
      } else {
        valid = true;
        const metro = inRanges(postcode, METRO_RANGES);
        price = metro ? 0 : 800;
        message = metro
          ? 'Estimated metro delivery: $0 — confirmed from your checkout address.'
          : 'Estimated non-metro delivery: $800 — confirmed from your checkout address.';
        value = `${postcode} - ${message}`;
      }
    }
    const assemblyAvailable = valid && inRanges(postcode, ASSEMBLY_RANGES);
    root.dataset.assemblyAvailable = assemblyAvailable ? 'true' : 'false';
    if (assemblyGroup) {
      assemblyGroup.hidden = !assemblyAvailable;
      assemblyGroup.setAttribute('aria-hidden', assemblyAvailable ? 'false' : 'true');
    }
    if (!assemblyAvailable) {
      const assemblySelect = root.querySelector('select[name="assembly"]');
      const noAssemblyRadio = root.querySelector(
        'input[name="assembly"][data-price="0"], input[name="assembly"][data-price-small="0"]'
      );
      if (assemblySelect && assemblySelect.selectedIndex !== 0) {
        assemblySelect.selectedIndex = 0;
        assemblySelect.dispatchEvent(new Event('change', { bubbles: true }));
      }
      if (noAssemblyRadio && !noAssemblyRadio.checked) {
        noAssemblyRadio.checked = true;
        noAssemblyRadio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
    field.setAttribute('aria-invalid', valid ? 'false' : 'true');
    priceInput.dataset.postcodeValid = valid ? 'true' : 'false';
    priceInput.dataset.postcode = valid ? postcode : '';
    priceInput.dataset.deliveryCharge = valid ? (price === 0 ? '$0' : '$800') : '';
    priceInput.dataset.price = String(price);
    priceInput.dataset.priceSmall = String(price);
    priceInput.dataset.priceLarge = String(price);
    priceInput.value = value;
    status.textContent = message;
    status.classList.toggle('is-valid', valid);
    status.classList.toggle('is-error', !valid);
    priceInput.dispatchEvent(new Event('change', { bubbles: true }));
  }
  const init = () => document.querySelectorAll('[data-sauna-postcode]').forEach(updateDelivery);
  document.addEventListener('input', (event) => {
    const field = event.target.closest?.('[data-sauna-postcode]');
    if (field) updateDelivery(field);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
